<template>
    <rkm-modal
        :loading="loading"
        :title="`Itens (${item.nome})`"
        persistent
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="materiais"
            @filtered="materiaisFiltered = $event"
            sort-by="nome"
        >
            <template #head(permiteControlar)="">
                <rkm-form-checkbox
                    :disabled="disabledSelectAll"
                    :indeterminate="indeterminate"
                    :value="true"
                    @change="selectAll"
                    v-model="selectedAll"
                />
            </template>

            <template v-slot:cell(permiteControlar)="{ item }">
                <rkm-form-checkbox
                    :value="true"
                    v-model="item.permiteControlar"
                />
            </template>
        </rkm-table>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

// Others.
import { object } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'permiteControlar',
                    label: 'Permite controlar',
                    class: 'col-min text-center'
                },
                {
                    key: 'nome',
                    label: 'Nome',
                    sortable: true,
                },
            ]
        },
        disabledSelectAll() {

            return !this.materiais
                .filter(sg => this.materiaisFiltered.find(sgf => sgf.id === sg.id))                
        }
    },
    data: () => ({
        item: {},
        materiais: [],
        materiaisFiltered: [],
        indeterminate: false,
        selectedAll: false,
    }),
    methods: {
        open(item) {

            this.item = item
            this.materiais = this.clone(item.materiais)
            this.materiaisFiltered = this.clone(this.materiais)

            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        selectAll(permitido) {

            this.materiais
                .filter(sg => this.materiaisFiltered.find(sgf => sgf.id === sg.id))
                .map(sg => sg.permiteControlar = permitido)
        },
        save() {

            const semPermissoes = !this.materiais.find(sg => sg.permiteControlar)

            if (this.item.permiteControlar && semPermissoes) {

                this.showConfirmation(
                    `Deseja remover a permissão do grupo ${this.item.nome}?`,
                    async () => this.handleSave(false),
                    async () => this.handleSave(true)
                )

                return
            }

            this.handleSave(this.item.permiteControlar || (!this.item.permiteControlar && !semPermissoes))
        },
        handleSave(permissaoGrupo) {

            this.item.permiteControlar = permissaoGrupo
            this.item.materiais = this.clone(this.materiais)

            this.$refs.Modal.hide()
        },
        handleSelectAllStatus() {

            this.indeterminate = false

            const materiaisFiltered = this.materiais
                .filter(sg => this.materiaisFiltered.find(sgf => sgf.id === sg.id))

            const quantidadePermitida = materiaisFiltered.filter(sg => sg.permiteControlar).length

            this.selectedAll = quantidadePermitida > 0 && quantidadePermitida == materiaisFiltered.length

            if (quantidadePermitida > 0 && quantidadePermitida != materiaisFiltered.length) {

                this.indeterminate = true
            }
        }
    },
    mixins: [object],
    watch: {
        materiais: {
            deep: true,
            handler() {

                this.handleSelectAllStatus()
            }
        },
        materiaisFiltered() {

            this.handleSelectAllStatus()
        }
    }
}
</script>